/*
  Makes the drop-in mobile menu (ll-menu.js, unedited) work inside Dawn's menu
  drawer. Load after global.js and before ll-menu.js.

  Dawn's MenuDrawer binds a "close submenu" click handler to every <button> in
  the drawer, so tapping a category row or Back would also close the drawer.
  Replacing the menu's buttons with clones drops that handler; ll-menu.js then
  binds its own handlers to the clones.
*/
(() => {
  document
    .querySelectorAll('header-drawer [data-llm-mobile] button')
    .forEach((button) => button.replaceWith(button.cloneNode(true)));
})();